import { STANDARDINSTÄLLNINGAR } from './AttGoraTyper';

import type { AttGöraInställningar } from './AttGoraTyper';

/**
 * Läsning och skrivning av att göra-listans lokala state.
 *
 * Egen modul utan tjänsteberoenden: hjälparna ska gå att testa utan att dra in
 * axios och Firebase, och de är rena funktioner utan React-koppling.
 */

export const NYCKEL_INSTÄLLNINGAR = 'att-gora-installningar';
export const NYCKEL_KLARA = 'att-gora-klara';

/** Stabil referens så att memos inte invalideras varje rendering. */
export const TOM_LISTA: string[] = [];

function läsRått(nyckel: string): unknown {
  if (typeof window === 'undefined') return undefined;
  try {
    const rå = window.localStorage.getItem(nyckel);
    return rå ? JSON.parse(rå) : undefined;
  } catch {
    return undefined;
  }
}

export function skriv(nyckel: string, värde: unknown) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(nyckel, JSON.stringify(värde));
  } catch {
    // Full eller blockerad localStorage ska inte krascha headern.
  }
}

/** Objektmerge så att nya inställningsfält får sitt standardvärde. */
export function läsInställningar(nyckel: string): AttGöraInställningar {
  const värde = läsRått(nyckel);
  if (!värde || typeof värde !== 'object' || Array.isArray(värde)) return STANDARDINSTÄLLNINGAR;
  const sammanslagen = { ...STANDARDINSTÄLLNINGAR, ...(värde as AttGöraInställningar) };
  // `dolda` är en lista och får aldrig objektmerge:as.
  return { ...sammanslagen, dolda: Array.isArray(sammanslagen.dolda) ? sammanslagen.dolda : [] };
}

/**
 * Listor måste läsas som listor. Ett tidigare fel spred arrayen i ett objekt-
 * literal, vilket gjorde `["a"]` till `{0: "a"}` och kraschade på `.includes`.
 * Allt som inte är en array kastas därför bort här.
 */
export function läsLista(nyckel: string): string[] {
  const värde = läsRått(nyckel);
  return Array.isArray(värde) ? värde.filter((v): v is string => typeof v === 'string') : [];
}
